import { c as _c } from "react/compiler-runtime";
import { BrandLogoLink } from 'shared/components/brand-logo-link';
import { DesktopActions } from 'shared/components/navbar/components/desktop-actions';
import { DesktopMenu } from 'shared/components/navbar/components/desktop-menu';
import { MobileActions } from 'shared/components/navbar/components/mobile-actions';
import { NavbarBase } from 'shared/components/navbar/components/navbar-base';
import { NavbarSkeleton } from 'shared/components/navbar/components/navbar-skeleton';
import { useMenuItems } from 'shared/components/navbar/hooks/use-menu-items';
import { useNavbarLayout } from 'shared/components/navbar/hooks/use-navbar-layout';
import { useFirstAvailableRoute } from 'shared/hooks/use-first-available-route';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import useUser from 'shared/hooks/use-user';
export function Navbar() {
  const $ = _c(20);
  const {
    i18n
  } = useLocoTranslation();
  const {
    isDisabled,
    isLoading,
    user
  } = useUser();
  const {
    menuItems,
    isReady
  } = useMenuItems();
  const {
    firstAvailableRoute
  } = useFirstAvailableRoute();
  const t0 = i18n?.language;
  const t1 = user?.dashboardLocale;
  let t2;
  if ($[0] !== isLoading || $[1] !== isReady || $[2] !== menuItems.length || $[3] !== t0 || $[4] !== t1) {
    t2 = {
      isLoading,
      isMenuReady: isReady,
      language: t0,
      menuItemCount: menuItems.length,
      userLocale: t1
    };
    $[0] = isLoading;
    $[1] = isReady;
    $[2] = menuItems.length;
    $[3] = t0;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const {
    desktopActionsRef,
    desktopMenuRef,
    isDesktop,
    isMounted,
    navRef
  } = useNavbarLayout(t2);
  const t3 = user && !isDisabled ? firstAvailableRoute : undefined;
  let t4;
  if ($[6] !== t3) {
    t4 = <BrandLogoLink href={t3} />;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== desktopActionsRef || $[9] !== desktopMenuRef || $[10] !== isDesktop || $[11] !== isLoading || $[12] !== isMounted || $[13] !== isReady || $[14] !== menuItems) {
    t5 = !isMounted ? <NavbarSkeleton items={menuItems} /> : isDesktop ? <><DesktopMenu isLoading={isLoading} isReady={isReady} items={menuItems} menuRef={desktopMenuRef} /><DesktopActions actionsRef={desktopActionsRef} /></> : <MobileActions />;
    $[8] = desktopActionsRef;
    $[9] = desktopMenuRef;
    $[10] = isDesktop;
    $[11] = isLoading;
    $[12] = isMounted;
    $[13] = isReady;
    $[14] = menuItems;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  let t6;
  if ($[16] !== navRef || $[17] !== t4 || $[18] !== t5) {
    t6 = <NavbarBase contentRef={navRef}>{t4}{t5}</NavbarBase>;
    $[16] = navRef;
    $[17] = t4;
    $[18] = t5;
    $[19] = t6;
  } else {
    t6 = $[19];
  }
  return t6;
}